/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  ApiPetCalendarEvent,
  ApiPetCalendarEventFromJSON,
  ApiPetCalendarEventToJSON,
  ApiPetComment,
  ApiPetCommentFromJSON,
  ApiPetCommentToJSON,
  ApiPetFormConfigurationResponse,
  ApiPetFormConfigurationResponseFromJSON,
  ApiPetFormConfigurationResponseToJSON,
  ApiPetImage,
  ApiPetImageFromJSON,
  ApiPetImageToJSON,
  ApiPetPrescription,
  ApiPetPrescriptionFromJSON,
  ApiPetPrescriptionToJSON,
  ApiPetProfile,
  ApiPetProfileFromJSON,
  ApiPetProfileToJSON,
  ApiPetProfileResults,
  ApiPetProfileResultsFromJSON,
  ApiPetProfileResultsToJSON,
  ApiPetV2FormConfigurationResponse,
  ApiPetV2FormConfigurationResponseFromJSON,
  ApiPetV2FormConfigurationResponseToJSON,
} from '../models';

export interface CreatePetCommentRequest {
  id: number;
  apiPetComment: ApiPetComment;
  xChewyAuthIDToken?: string;
  authorization?: string;
}

export interface CreatePetProfileRequest {
  apiPetProfile: ApiPetProfile;
  xChewyAuthIDToken?: string;
  authorization?: string;
}

export interface DeletePetProfileRequest {
  id: number;
  statusReason: DeletePetProfileStatusReasonEnum;
  xChewyAuthIDToken?: string;
  authorization?: string;
  cookie?: string;
}

export interface GetPetCalendarEventsRequest {
  id: number;
  xChewyAuthIDToken?: string;
  authorization?: string;
  daysAhead?: number;
  startDate?: Date;
}

export interface GetPetFormConfigurationRequest {
  xChewyAuthIDToken?: string;
  authorization?: string;
  petTypeId?: number;
  petProfileId?: number;
  usecase?: GetPetFormConfigurationUsecaseEnum;
}

export interface GetPetPrescriptionsRequest {
  id: number;
  xChewyAuthIDToken?: string;
  authorization?: string;
  size?: number;
  page?: number;
  sortBy?: string;
}

export interface GetPetProfileRequest {
  id: number;
  xChewyAuthIDToken?: string;
  authorization?: string;
  includeOwnerName?: boolean;
}

export interface GetPetProfilesRequest {
  xChewyAuthIDToken?: string;
  authorization?: string;
  start?: number;
  page?: number;
  limit?: number;
  pharmacyEligibleOnly?: boolean;
  vetDietEligibleOnly?: boolean;
  includeOwnerName?: boolean;
  petStatus?: GetPetProfilesPetStatusEnum;
  excludePetStatus?: GetPetProfilesExcludePetStatusEnum;
}

export interface GetPetV2FormConfigurationRequest {
  xChewyAuthIDToken: string;
  xChewyAuthAccessToken: string;
  usecase?: GetPetV2FormConfigurationUsecaseEnum;
  petProfileId?: number;
}

export interface UpdatePetProfileRequest {
  id: number;
  apiPetProfile: ApiPetProfile;
  xChewyAuthIDToken?: string;
  authorization?: string;
}

export interface UploadPetImageRequest {
  apiPetImage: ApiPetImage;
  xChewyAuthIDToken?: string;
  authorization?: string;
}

export interface UploadPetImageV2Request {
  body: any;
  xChewyAuthIDToken?: string;
  authorization?: string;
}

/**
 *
 */
export class PetProfileApi extends runtime.BaseAPI {
  /**
   * Create a comment for a given pet
   * Create Pet Comment
   */
  async createPetCommentRaw(
    requestParameters: CreatePetCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetComment>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling createPetComment.',
      );
    }

    if (requestParameters.apiPetComment === null || requestParameters.apiPetComment === undefined) {
      throw new runtime.RequiredError(
        'apiPetComment',
        'Required parameter requestParameters.apiPetComment was null or undefined when calling createPetComment.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}/comments`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPetCommentToJSON(requestParameters.apiPetComment),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetCommentFromJSON(jsonValue));
  }

  /**
   * Create a comment for a given pet
   * Create Pet Comment
   */
  async createPetComment(
    requestParameters: CreatePetCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetComment> {
    const response = await this.createPetCommentRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Create a pet profile
   * Create Pet Profile
   */
  async createPetProfileRaw(
    requestParameters: CreatePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetProfile>> {
    if (requestParameters.apiPetProfile === null || requestParameters.apiPetProfile === undefined) {
      throw new runtime.RequiredError(
        'apiPetProfile',
        'Required parameter requestParameters.apiPetProfile was null or undefined when calling createPetProfile.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPetProfileToJSON(requestParameters.apiPetProfile),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetProfileFromJSON(jsonValue));
  }

  /**
   * Create a pet profile
   * Create Pet Profile
   */
  async createPetProfile(
    requestParameters: CreatePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetProfile> {
    const response = await this.createPetProfileRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Delete a pet profile for a given pet ID
   * Delete Pet Profile
   */
  async deletePetProfileRaw(
    requestParameters: DeletePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling deletePetProfile.',
      );
    }

    if (requestParameters.statusReason === null || requestParameters.statusReason === undefined) {
      throw new runtime.RequiredError(
        'statusReason',
        'Required parameter requestParameters.statusReason was null or undefined when calling deletePetProfile.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.statusReason !== undefined) {
      queryParameters['statusReason'] = requestParameters.statusReason;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    if (requestParameters.cookie !== undefined && requestParameters.cookie !== null) {
      headerParameters['Cookie'] = String(requestParameters.cookie);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a pet profile for a given pet ID
   * Delete Pet Profile
   */
  async deletePetProfile(
    requestParameters: DeletePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<void> {
    await this.deletePetProfileRaw(requestParameters, initOverrides);
  }

  /**
   * Get calendar events for a given pet
   * Get Pet Calendar Events
   */
  async getPetCalendarEventsRaw(
    requestParameters: GetPetCalendarEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetCalendarEvent>>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getPetCalendarEvents.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.daysAhead !== undefined) {
      queryParameters['daysAhead'] = requestParameters.daysAhead;
    }

    if (requestParameters.startDate !== undefined) {
      queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}/calendar-events`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetCalendarEventFromJSON),
    );
  }

  /**
   * Get calendar events for a given pet
   * Get Pet Calendar Events
   */
  async getPetCalendarEvents(
    requestParameters: GetPetCalendarEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetCalendarEvent>> {
    const response = await this.getPetCalendarEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Retrieve form configuration based on pet type or pet profile ID
   * Get Pet Form Configuration
   */
  async getPetFormConfigurationRaw(
    requestParameters: GetPetFormConfigurationRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetFormConfigurationResponse>> {
    const queryParameters: any = {};

    if (requestParameters.petTypeId !== undefined) {
      queryParameters['petTypeId'] = requestParameters.petTypeId;
    }

    if (requestParameters.petProfileId !== undefined) {
      queryParameters['petProfileId'] = requestParameters.petProfileId;
    }

    if (requestParameters.usecase !== undefined) {
      queryParameters['usecase'] = requestParameters.usecase;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/form`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPetFormConfigurationResponseFromJSON(jsonValue),
    );
  }

  /**
   * Retrieve form configuration based on pet type or pet profile ID
   * Get Pet Form Configuration
   */
  async getPetFormConfiguration(
    requestParameters: GetPetFormConfigurationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetFormConfigurationResponse> {
    const response = await this.getPetFormConfigurationRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get prescriptions for a given pet
   * Get Pet Prescriptions
   */
  async getPetPrescriptionsRaw(
    requestParameters: GetPetPrescriptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetPrescription>>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getPetPrescriptions.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.size !== undefined) {
      queryParameters['size'] = requestParameters.size;
    }

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page;
    }

    if (requestParameters.sortBy !== undefined) {
      queryParameters['sortBy'] = requestParameters.sortBy;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}/rx`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetPrescriptionFromJSON),
    );
  }

  /**
   * Get prescriptions for a given pet
   * Get Pet Prescriptions
   */
  async getPetPrescriptions(
    requestParameters: GetPetPrescriptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetPrescription>> {
    const response = await this.getPetPrescriptionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get a pet profile for a given pet ID
   * Get Pet Profile
   */
  async getPetProfileRaw(
    requestParameters: GetPetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetProfile>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getPetProfile.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.includeOwnerName !== undefined) {
      queryParameters['includeOwnerName'] = requestParameters.includeOwnerName;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetProfileFromJSON(jsonValue));
  }

  /**
   * Get a pet profile for a given pet ID
   * Get Pet Profile
   */
  async getPetProfile(
    requestParameters: GetPetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetProfile> {
    const response = await this.getPetProfileRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get pet profiles
   * Get Pet Profiles
   */
  async getPetProfilesRaw(
    requestParameters: GetPetProfilesRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetProfileResults>> {
    const queryParameters: any = {};

    if (requestParameters.start !== undefined) {
      queryParameters['start'] = requestParameters.start;
    }

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.pharmacyEligibleOnly !== undefined) {
      queryParameters['pharmacyEligibleOnly'] = requestParameters.pharmacyEligibleOnly;
    }

    if (requestParameters.vetDietEligibleOnly !== undefined) {
      queryParameters['vetDietEligibleOnly'] = requestParameters.vetDietEligibleOnly;
    }

    if (requestParameters.includeOwnerName !== undefined) {
      queryParameters['includeOwnerName'] = requestParameters.includeOwnerName;
    }

    if (requestParameters.petStatus !== undefined) {
      queryParameters['petStatus'] = requestParameters.petStatus;
    }

    if (requestParameters.excludePetStatus !== undefined) {
      queryParameters['excludePetStatus'] = requestParameters.excludePetStatus;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPetProfileResultsFromJSON(jsonValue),
    );
  }

  /**
   * Get pet profiles
   * Get Pet Profiles
   */
  async getPetProfiles(
    requestParameters: GetPetProfilesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetProfileResults> {
    const response = await this.getPetProfilesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Retrieve form configuration based on pet type or pet profile ID
   * Get Pet V2 Form Configuration
   */
  async getPetV2FormConfigurationRaw(
    requestParameters: GetPetV2FormConfigurationRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetV2FormConfigurationResponse>> {
    if (
      requestParameters.xChewyAuthIDToken === null ||
      requestParameters.xChewyAuthIDToken === undefined
    ) {
      throw new runtime.RequiredError(
        'xChewyAuthIDToken',
        'Required parameter requestParameters.xChewyAuthIDToken was null or undefined when calling getPetV2FormConfiguration.',
      );
    }

    if (
      requestParameters.xChewyAuthAccessToken === null ||
      requestParameters.xChewyAuthAccessToken === undefined
    ) {
      throw new runtime.RequiredError(
        'xChewyAuthAccessToken',
        'Required parameter requestParameters.xChewyAuthAccessToken was null or undefined when calling getPetV2FormConfiguration.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.usecase !== undefined) {
      queryParameters['usecase'] = requestParameters.usecase;
    }

    if (requestParameters.petProfileId !== undefined) {
      queryParameters['petProfileId'] = requestParameters.petProfileId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (
      requestParameters.xChewyAuthAccessToken !== undefined &&
      requestParameters.xChewyAuthAccessToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Access-Token'] = String(
        requestParameters.xChewyAuthAccessToken,
      );
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v2/pets/form`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPetV2FormConfigurationResponseFromJSON(jsonValue),
    );
  }

  /**
   * Retrieve form configuration based on pet type or pet profile ID
   * Get Pet V2 Form Configuration
   */
  async getPetV2FormConfiguration(
    requestParameters: GetPetV2FormConfigurationRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetV2FormConfigurationResponse> {
    const response = await this.getPetV2FormConfigurationRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Update a pet profile for a given pet ID
   * Update Pet Profile
   */
  async updatePetProfileRaw(
    requestParameters: UpdatePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetProfile>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling updatePetProfile.',
      );
    }

    if (requestParameters.apiPetProfile === null || requestParameters.apiPetProfile === undefined) {
      throw new runtime.RequiredError(
        'apiPetProfile',
        'Required parameter requestParameters.apiPetProfile was null or undefined when calling updatePetProfile.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pets/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPetProfileToJSON(requestParameters.apiPetProfile),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetProfileFromJSON(jsonValue));
  }

  /**
   * Update a pet profile for a given pet ID
   * Update Pet Profile
   */
  async updatePetProfile(
    requestParameters: UpdatePetProfileRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetProfile> {
    const response = await this.updatePetProfileRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Upload a pet image
   * Upload Pet Image
   */
  async uploadPetImageRaw(
    requestParameters: UploadPetImageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetImage>> {
    if (requestParameters.apiPetImage === null || requestParameters.apiPetImage === undefined) {
      throw new runtime.RequiredError(
        'apiPetImage',
        'Required parameter requestParameters.apiPetImage was null or undefined when calling uploadPetImage.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-images`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPetImageToJSON(requestParameters.apiPetImage),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetImageFromJSON(jsonValue));
  }

  /**
   * Upload a pet image
   * Upload Pet Image
   */
  async uploadPetImage(
    requestParameters: UploadPetImageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetImage> {
    const response = await this.uploadPetImageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Upload a pet image using application/octet-stream
   * Upload Pet Image
   */
  async uploadPetImageV2Raw(
    requestParameters: UploadPetImageV2Request,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetImage>> {
    if (requestParameters.body === null || requestParameters.body === undefined) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling uploadPetImageV2.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/octet-stream';

    if (
      requestParameters.xChewyAuthIDToken !== undefined &&
      requestParameters.xChewyAuthIDToken !== null
    ) {
      headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
    }

    if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
      headerParameters['Authorization'] = String(requestParameters.authorization);
    }

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-binary-images`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.body as any,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetImageFromJSON(jsonValue));
  }

  /**
   * Upload a pet image using application/octet-stream
   * Upload Pet Image
   */
  async uploadPetImageV2(
    requestParameters: UploadPetImageV2Request,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetImage> {
    const response = await this.uploadPetImageV2Raw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const DeletePetProfileStatusReasonEnum = {
  Unknown: 'UNKNOWN',
  Deceased: 'DECEASED',
  SwitchedRetailers: 'SWITCHED_RETAILERS',
  Other: 'OTHER',
} as const;
export type DeletePetProfileStatusReasonEnum = typeof DeletePetProfileStatusReasonEnum[keyof typeof DeletePetProfileStatusReasonEnum];
/**
 * @export
 */
export const GetPetFormConfigurationUsecaseEnum = {
  Basic: 'basic',
  Pharmacy: 'pharmacy',
  VetDiet: 'vetDiet',
  Cwav: 'cwav',
  Insurance: 'insurance',
} as const;
export type GetPetFormConfigurationUsecaseEnum = typeof GetPetFormConfigurationUsecaseEnum[keyof typeof GetPetFormConfigurationUsecaseEnum];
/**
 * @export
 */
export const GetPetProfilesPetStatusEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Deleted: 'DELETED',
} as const;
export type GetPetProfilesPetStatusEnum = typeof GetPetProfilesPetStatusEnum[keyof typeof GetPetProfilesPetStatusEnum];
/**
 * @export
 */
export const GetPetProfilesExcludePetStatusEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Deleted: 'DELETED',
} as const;
export type GetPetProfilesExcludePetStatusEnum = typeof GetPetProfilesExcludePetStatusEnum[keyof typeof GetPetProfilesExcludePetStatusEnum];
/**
 * @export
 */
export const GetPetV2FormConfigurationUsecaseEnum = {
  Basic: 'basic',
  Pharmacy: 'pharmacy',
  VetDiet: 'vetDiet',
  Cwav: 'cwav',
  Insurance: 'insurance',
} as const;
export type GetPetV2FormConfigurationUsecaseEnum = typeof GetPetV2FormConfigurationUsecaseEnum[keyof typeof GetPetV2FormConfigurationUsecaseEnum];
